export default function (params) {
  return {
    width: '100%',
    height: '100%',
    overflowX: 'scroll',
  }
}
